import { render } from "./AboutView.html?vue&type=template&id=4b7521a4&ts=true&external"
import script from "./AboutView.ts?vue&type=script&lang=ts&external"
export * from "./AboutView.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__